import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class OperationParameter extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/operation/parameter'
    super(store, path)
  }
}
